import { documents } from "@/mocks/documentos";
import DocumentStatusBadge from "./DocumentStatusBadge";

interface ProjectSourcesPanelProps {
  onViewDocument: (id: string) => void;
}

const projectGroups = [
  {
    id: "prj-001",
    name: "Inventário Arbóreo Goiânia Norte",
    client: "Prefeitura de Goiânia",
    docs: documents.filter((d) => d.projectId === "prj-001"),
  },
  {
    id: "prj-002",
    name: "Arborização Loteamento Jardim Verde",
    client: "Incorporadora VerdeVida",
    docs: documents.filter((d) => d.projectId === "prj-002"),
  },
  {
    id: "prj-003",
    name: "Compensação Reserva Ecológica Buritis",
    client: "Construtora Horizonte",
    docs: documents.filter((d) => d.projectId === "prj-003"),
  },
  {
    id: "prj-004",
    name: "Reflorestamento APP Córrego Matinha",
    client: "Secretaria de Meio Ambiente",
    docs: documents.filter((d) => d.projectId === "prj-004"),
  },
  {
    id: "prj-006",
    name: "Parque Municipal Buriti Sereno",
    client: "Prefeitura de Goiânia",
    docs: documents.filter((d) => d.projectId === "prj-006"),
  },
];

export default function ProjectSourcesPanel({ onViewDocument }: ProjectSourcesPanelProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground-900">Fontes documentais por projeto</h3>

      {projectGroups.map((project) => {
        const totalDocs = project.docs.length;
        const pendingDocs = project.docs.filter((d) => d.status === "Em revisão" || d.status === "Rascunho").length;
        const expiredDocs = project.docs.filter((d) => d.status === "Vencido").length;
        const validatedDocs = project.docs.filter((d) => d.status === "Validado").length;
        const quality = totalDocs > 0 ? Math.round((validatedDocs / totalDocs) * 100) : 0;
        const hasFinalReport = project.docs.some((d) => d.type.includes("Relatório"));

        return (
          <div key={project.id} className="bg-white rounded-xl border border-background-200/70 p-4 md:p-5">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
              <div>
                <h4 className="text-base font-semibold text-foreground-900 font-heading">{project.name}</h4>
                <p className="text-xs text-foreground-500">{project.client}</p>
              </div>
              <div className="flex items-center gap-2">
                <button onClick={() => onViewDocument(project.docs[0]?.id || "")} className="px-3 py-1.5 text-xs font-semibold text-accent-700 bg-accent-50 rounded-lg hover:bg-accent-100 transition-colors whitespace-nowrap">
                  <i className="ri-folder-open-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
                  Abrir documentos
                </button>
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mb-4">
              <div className="bg-background-50 rounded-lg p-2.5 text-center">
                <div className="text-lg font-bold text-foreground-900 font-heading">{totalDocs}</div>
                <div className="text-[10px] text-foreground-500">Total docs</div>
              </div>
              <div className="bg-warning-50 rounded-lg p-2.5 text-center">
                <div className="text-lg font-bold text-warning-700 font-heading">{pendingDocs}</div>
                <div className="text-[10px] text-warning-600">Pendentes</div>
              </div>
              <div className="bg-danger-50 rounded-lg p-2.5 text-center">
                <div className="text-lg font-bold text-danger-700 font-heading">{expiredDocs}</div>
                <div className="text-[10px] text-danger-600">Vencidos</div>
              </div>
              <div className="bg-primary-50 rounded-lg p-2.5 text-center">
                <div className="text-lg font-bold text-primary-700 font-heading">{quality}%</div>
                <div className="text-[10px] text-primary-600">Qualidade</div>
              </div>
              <div className={`rounded-lg p-2.5 text-center ${hasFinalReport ? "bg-primary-50" : "bg-background-100"}`}>
                <i className={`${hasFinalReport ? "ri-check-line text-primary-600" : "ri-close-line text-foreground-400"} text-lg`} />
                <div className="text-[10px] text-foreground-500">Relatório final</div>
              </div>
            </div>

            {project.docs.length > 0 && (
              <div className="space-y-1.5">
                {project.docs.slice(0, 5).map((doc) => (
                  <div key={doc.id} className="flex items-center justify-between py-1.5 px-2 rounded-md hover:bg-background-50 transition-colors">
                    <div className="flex items-center gap-2 min-w-0">
                      <i className="ri-file-text-line text-foreground-400 w-4 h-4 flex items-center justify-center shrink-0" />
                      <button onClick={() => onViewDocument(doc.id)} className="text-sm text-foreground-700 hover:text-accent-600 transition-colors truncate text-left">{doc.title}</button>
                    </div>
                    <DocumentStatusBadge status={doc.status} />
                  </div>
                ))}
                {project.docs.length > 5 && (
                  <div className="text-xs text-foreground-400 text-center py-1">+ {project.docs.length - 5} documentos</div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}